import React from 'react';
import EntryPoints from '../../framework/nav/EntryPoints';
import { NavItem } from '../../framework/nav/NavItem';
import EmailProtection from '../../framework/common/EmailProtection';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

const ContactView = () => {
  return (
    <div>
      
      <Container fluid={true}>
        <div className="contact-container">
          {/* Header Section */}
          <div className="text-center mb-5">
            <h1 className="mb-4">Get In Touch</h1>
            <p className="lead text-muted mb-5">
              I'm always interested in new opportunities, collaborations, and connecting with fellow developers. 
              Whether you have a project idea, need support, or just want to chat about technology, feel free to reach out!
            </p>
          </div>

          {/* Contact Methods */}
          <Row className="mb-5">
            <Col md={6} className="mb-4">
              <Card className="h-100 border-0" style={{ boxShadow: '0 10px 15px -3px rgba(0,0,0,0.2), 0 4px 6px -2px rgba(0,0,0,0.1)' }}>
                <Card.Body className="text-center p-4">
                  <div className="mb-3">
                    <i className="fas fa-envelope fa-3x text-primary mb-3"></i>
                  </div>
                  <h4 className="card-title mb-3">Email</h4>
                  <p className="card-text mb-3">
                    For general inquiries, project discussions, or collaboration opportunities.
                  </p>
                  <EmailProtection className="btn btn-outline-primary" />
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={6} className="mb-4">
              <Card className="h-100 border-0" style={{ boxShadow: '0 10px 15px -3px rgba(0,0,0,0.2), 0 4px 6px -2px rgba(0,0,0,0.1)' }}>
                <Card.Body className="text-center p-4">
                  <div className="mb-3">
                    <i className="fab fa-linkedin fa-3x text-primary mb-3"></i>
                  </div>
                  <h4 className="card-title mb-3">LinkedIn</h4>
                  <p className="card-text mb-3">
                    Connect with me professionally and see my latest updates and achievements.
                  </p>
                  <a href="https://au.linkedin.com/in/lucamorrow" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                    View Profile
                  </a>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Support Section */}
          <section className="mb-5">
            <div className="text-center mb-4">
              <h2 className="mb-3">Need Support?</h2>
              <p className="lead text-muted">
                If you're using any of my Atlassian marketplace applications and need assistance, 
                I'm here to help you get the most out of them.
              </p>
            </div>
            
            <Row>
              <Col lg={8} className="mx-auto">
                <Card className="border-0" style={{ boxShadow: '0 10px 15px -3px rgba(0,0,0,0.2), 0 4px 6px -2px rgba(0,0,0,0.1)' }}>
                  <Card.Body className="p-4">
                    <div className="text-center mb-4">
                      <i className="fas fa-life-ring fa-2x text-success mb-3"></i>
                      <h4>Support Request Form</h4>
                    </div>
                    <p className="text-center mb-4">
                      For technical support, bug reports, or feature requests for my applications 
                      (QR Code Pro, Oxal, Unsplash for Confluence), please use the dedicated support form.
                    </p>
                    <div className="text-center">
                      <a 
                        href='https://docs.google.com/forms/d/e/1FAIpQLSeO-jVhQRqf7lF0WEhtmGy4p1TzN8TIdfldQL5jjzXxC8uO3g/viewform?usp=header' 
                        className="btn btn-success btn-lg"
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        Submit Support Request
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </section>

          {/* What I'm Working On */}
          <section className="mb-5">
            <div className="text-center mb-4">
              <h2 className="mb-3">Current Focus</h2>
              <p className="lead text-muted">
                Here's what I'm currently working on and interested in discussing:
              </p>
            </div>
            
            <Row>
              <Col md={4} className="mb-3">
                <div className="text-center">
                  <i className="fas fa-code fa-2x text-info mb-3"></i>
                  <h5>Web Development</h5>
                  <p className="text-muted">
                    React, TypeScript, and modern web technologies for creating engaging user experiences.
                  </p>
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <div className="text-center">
                  <i className="fab fa-atlassian fa-2x text-info mb-3"></i>
                  <h5>Atlassian Apps</h5>
                  <p className="text-muted">
                    Developing Confluence marketplace applications using the Forge platform.
                  </p>
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <div className="text-center">
                  <i className="fas fa-cube fa-2x text-info mb-3"></i>
                  <h5>3D Modeling</h5>
                  <p className="text-muted">
                    Creating 3D models and renders using Blender for various creative projects.
                  </p>
                </div>
              </Col>
            </Row>
          </section>

          {/* Response Time */}
          <section className="text-center mb-5">
            <Card className="border-0" style={{ boxShadow: '0 10px 15px -3px rgba(0,0,0,0.2), 0 4px 6px -2px rgba(0,0,0,0.1)' }}>
              <Card.Body className="p-4">
                <h4 className="mb-3">Response Time</h4>
                <p className="mb-2">
                  <strong>General Inquiries:</strong> I typically respond within 24-48 hours
                </p>
                <p className="mb-2">
                  <strong>Support Requests:</strong> I aim to respond within 1-2 business days
                </p>
                <p className="text-muted mb-0">
                  <small>Please note that response times may be longer during university exam periods.</small>
                </p>
              </Card.Body>
            </Card>
          </section>

          {/* Footer */}
          <section className="text-center mt-5 pt-4 border-top">
            <p className="text-muted">
              Looking forward to hearing from you! Whether it's about a potential collaboration, 
              a technical question, or just to say hello, don't hesitate to get in touch.
            </p>
          </section>
        </div>
      </Container>
    </div>
  );
};

class ContactEntryPoints implements EntryPoints {

  renderFullView = (navItem: NavItem, secondaryNavItems: string[], width: number, height: number): any => {
    return <ContactView />;
  }

  renderIntroView = (navItem: NavItem, secondaryNavItems: string[]): any => {
    return (
      <span>Get in touch for collaborations, support, or just to connect</span>
    );
  }

}

const contactEntryPoints = new ContactEntryPoints();
export default contactEntryPoints;
